import { Button } from "@blueprintjs/core";
import { genTextElement } from "../../../shared/utils/text";
import { TranscriptApi } from "../../../shared/services/transcript.api";
import { useState } from "react";
import { TAny } from "../../../shared/types/common";
import { StoreType } from "polotno/model/store";
import { PageType } from "polotno/model/page-model";
import { TTranscriptDTO } from "../../../shared/types/transcript";
import { ElementType } from "polotno/model/group-model";

const GenSummarize = ({ store }: { store: StoreType }) => {
  const storeJson = store.toJSON() as TAny;
  const videoEl = storeJson.pages[0].children?.find(
    (_: TAny) => _.type === "video"
  );

  const [isGenerating, setIsGenerating] = useState(false);
  const language = "en";
  const processId = store.custom?.processId;

  const handleGenerateSubtitles = async () => {
    if (!videoEl) return;

    removeOldTranscript();
    setIsGenerating(true);

    try {
      if (processId) {
        const body = {
          processId,
        };
        const response = await TranscriptApi.genSummarize(body);
        if (response.success && response.segments.length > 0) {
          addTranscriptElement(response);
        }
      }
    } catch (error) {
      console.error("Error processing video:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  const removeOldTranscript = () => {
    const oldIds: string[] = [];
    store.pages.forEach((page: PageType) => {
      page.children.forEach((element: ElementType) => {
        if (element.custom?.type === "transcript") {
          oldIds.push(element.id);
        }
      });
    });

    store.deleteElements(oldIds);
  };

  const addTranscriptElement = (response: TTranscriptDTO) => {
    const canvasWidth = store.width;
    const canvasHeight = store.height;
    const fontSize = 30;
    const lineHeight = 1.2;
    const textWidth = canvasWidth;
    const textX = 0;
    const textYOffset = 10;
    for (const transcript of response.segments) {
      // Calculate how many characters can fit in one line
      const charsPerLine = Math.floor(canvasWidth / (fontSize * 0.6)); // Approximate character width
      const lines = Math.ceil(transcript.text.length / charsPerLine);
      const textHeight = fontSize * lineHeight * lines;
      const textY = canvasHeight - textHeight - textYOffset;
      const textEl = genTextElement(
        transcript.id,
        transcript.text,
        transcript.start,
        transcript.end,
        textWidth,
        textHeight,
        textX,
        textY
      );
      store.activePage.addElement({
        ...textEl,
        custom: { ...textEl?.custom, lang: language, isOriginal: true },
      });
    }

    store.set({
      custom: {
        langSegment: response.segments,
        processId: response.processId,
        isSummarize: true,
      },
    });

    store.openSidePanel("transcript-panel");
  };

  return (
    <Button
      icon="document"
      text={`Summarize`}
      intent="warning"
      loading={isGenerating}
      onClick={() => handleGenerateSubtitles()}
      disabled={!processId}
    />
  );
};

export default GenSummarize;
